export const WORKFLOW = 'Workflow';
export const ACTION_SET = 'ActionSet';